var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlarmIcon = function SvgAlarmIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uB808\\uC774\\uC5B4_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A3A8AF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.4,5.4L15,3.1C14.9,3,14.8,3,14.6,3c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4 c0,0.1,0.1,0.3,0.2,0.4l2.3,2.3c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c0.1,0,0.1-0.1,0.2-0.1 c0-0.1,0.1-0.1,0.1-0.2c0-0.1,0-0.1,0-0.2c0-0.1,0-0.1,0-0.2C17.4,5.6,17.4,5.5,17.4,5.4L17.4,5.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.7,3.1C5.6,3,5.5,3,5.3,3C5.2,3,5.1,3,5,3.1L2.6,5.4C2.4,5.7,2.4,6,2.6,6.2C2.7,6.3,2.9,6.4,3,6.4 c0.1,0,0.3-0.1,0.4-0.2l2.3-2.3c0.1-0.1,0.2-0.2,0.2-0.4C5.9,3.4,5.8,3.2,5.7,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,10.3c0,0,0-0.1,0-0.2l0,0c-0.2-3.4-2.9-6.1-6.2-6.2H9.7c-3.4,0.2-6.1,2.9-6.2,6.2l0,0c0,0.1,0,0.1,0,0.2 v0.4c0,0,0,0.1,0,0.1l0,0c0.2,3.4,2.9,6,6.2,6.2h0.7c3.4-0.2,6.1-2.9,6.2-6.2l0,0c0,0,0-0.1,0-0.1V10.3z M13.8,11H10 c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4V6.6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v3.3h3.3c0.3,0,0.5,0.2,0.5,0.5 c0,0.1-0.1,0.3-0.2,0.4C14.1,11,14,11,13.8,11z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlarmIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AlarmIcon.b6bad5e7.svg";
export { ForwardRef as ReactComponent };